export default "__VITE_ASSET__IkfKW9H8__"